import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { salesByCustomerSearchSchema } from '../../features/reports/operational-search'
import { SalesByCustomerPage } from '../../features/reports/sales-by-customer-page'

export const Route = createFileRoute('/_app/sales-by-customer')({
  staticData: { crumb: 'salesByCustomer' },
  validateSearch: salesByCustomerSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: SalesByCustomerPage,
})
